import styled from "styled-components";

import Grid from "@anwb/grid";

export const TrainerGridWrapper = styled(Grid)`
  margin: 0 auto;
  width: 100%;
  margin-bottom: 1rem;
`;
